module.exports = __webpack_public_path__ + "static/media/mobile-valet.d719c40e.png";